import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ErrorHandler, NgModule, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { formlyConfig } from '@app/formly';
import { ContactUsModalComponent } from '@app/root/components/contact-us-modal/contact-us-modal.component';
import { PrivacyComponent } from '@app/root/components/privacy/privacy.component';
import { SupportComponent } from '@app/root/components/support/support.component';
import { ToastsComponent } from '@app/root/components/toasts/toasts.component';
import { AppRoutingModule } from '@app/routes.module';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { AppService } from '@services/app.service';
import { AuthInterceptor } from '@services/auth.interceptor';
import { LogService } from '@services/log.service';
import { LoggingInterceptor } from '@services/logging.interceptor';
import { MetricsInterceptor } from '@services/metrics.interceptor';
import { CaptchaComponent } from '@shared/components/captcha.component';
import { FormlyFieldListComponent } from '@shared/components/forms/formly-fields/formly-field-list/formly-field-list.component';
import { FormlyFieldRangeComponent } from '@shared/components/forms/formly-fields/formly-field-range.component';
import { ThemeToggleComponent } from '@shared/components/theme-toggle/theme-toggle.component';
import { SharedModule } from '@shared/shared.module';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { NgxPaginationModule } from 'ngx-pagination';
import { provideDataViewFilterOptions } from '@shared/dataview/options/built-in-loaders';

@NgModule({
  declarations: [
    AppComponent,
    PrivacyComponent,
    ToastsComponent,
    SupportComponent,
    FormlyFieldListComponent,
    FormlyFieldRangeComponent,
    ContactUsModalComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    SharedModule,
    MonacoEditorModule.forRoot(),
    NgxPaginationModule,
    AppRoutingModule,
    FormlyBootstrapModule,
    FormlyModule.forRoot(formlyConfig),
    LeafletModule,
    NgbPopoverModule,
    CaptchaComponent,
    ThemeToggleComponent,
  ],
  providers: [
    provideZoneChangeDetection(),
    CurrencyPipe,
    DecimalPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoggingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MetricsInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useExisting: LogService,
    },
    provideAppInitializer(() => {
      const initializerFn = ((appService: AppService) => async () => {
        await Promise.all([appService.loadFeatureFlags(), appService.checkVersion()]);
      })(inject(AppService));
      return initializerFn();
    }),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideDataViewFilterOptions(),
  ],
})
export class AppModule {}
